import { LogGroup, Rect } from "../.././MyHelpers";
import { PlayWindow } from "../../api";
import { ReelMapper, ReelSymbolsToDisplay } from "../SpinAnimation/ReelMapper";
import { IReelMapper, IReelSetMapper } from "../SpinAnimation/ReelSetMapper";
import { S2_ReelMapper } from "./ReelMapper";
import { S2_SpinTargetParams } from "./SpinTargetParams";
// export namespace S2
// {

export class S2_ReelSetMapperOverlay
{
	public rect: Rect;
	public symbol: number;

	public constructor(rect: Rect, symbol: number) {
		this.rect = rect;
		this.symbol = symbol;
	}
}

export class S2_ReelOverlay
{
	public symbols: number[] = [];

	public constructor(reelWindowHeight: number, defaultSymbol: number) {
		for (let i = 0; i < reelWindowHeight; i++) {
			this.symbols.push(defaultSymbol);
		}
	}
}

export class S2_ReelSetMapper implements IReelSetMapper
{
	//private numberOfReels: number = 0;

	private windowSymbolSize: PlayWindow = null;
	private reelHeights: number[] = [];
	private reelSet: number[][] = [[]];
	private reelSetStartPositions: number[] = [];

	private reelMappers: S2_ReelMapper[] = [];
	private logGroup: LogGroup = null;

	private overlays: S2_ReelSetMapperOverlay[] = [];


	private flatOverlay: S2_ReelOverlay[] = [];

	private numReelsOverlayed: number = 0;

	public constructor(windowSymbolSize: PlayWindow, logGroup: LogGroup) {
		this.logGroup = logGroup.Add("ReelSetMapper");

		this.windowSymbolSize = windowSymbolSize;

		// prepare flat overlay
		for (let ri = 0; ri < this.windowSymbolSize.Width; ri++) {
			let reelOverlay: S2_ReelOverlay = new S2_ReelOverlay(this.windowSymbolSize.Height, ReelMapper.NoOverlaySymbolIndex);
			this.flatOverlay.push(reelOverlay);
		}
	}

	public AddReelMapper(reelMapper: S2_ReelMapper): void {
		this.reelMappers.push(reelMapper)

		reelMapper.AddClearOverlayCallback((reelIndex: number) => {
			// when all reels are clear, clear all the overlays

			if (this.numReelsOverlayed > 0) {
				this.numReelsOverlayed--;

				if (this.numReelsOverlayed == 0) {
					this.ClearOverlays();
				}
			}
		});
	}

	public GetReelMapper(reelIndex: number): IReelMapper
	{
		return this.reelMappers[reelIndex];
	}

	public GetReelMappers(): IReelMapper[]
	{
		return this.reelMappers;
	}

	// SetReelSet(reelSet: number[][], startPositions: number[]): void {

	// 	if (reelSet.length != this.windowSymbolSize.width) {
	// 		Log.Error(this.logGroup, "Reel set contains " + reelSet.length + " reels, expecting " + this.windowSymbolSize.width);
	// 		return;
	// 	}

	// 	if (startPositions.length != this.windowSymbolSize.width) {
	// 		Log.Error(this.logGroup, "Start positions contains " + startPositions.length + " reels, expecting " + this.windowSymbolSize.width);
	// 		return;
	// 	}

	// 	this.reelSet = reelSet;
	// 	this.reelSetStartPositions = startPositions;

	// 	for (let i = 0; i < this.reelMappers.length; i++) {
	// 		this.reelMappers[i].SetReel(reelSet[i], 0, this.windowSymbolSize.height);
	// 	}
	// }

	public SetTargets(targets: S2_SpinTargetParams[], force: boolean = false): void {

		if (targets.length != this.reelMappers.length) {
			throw "Target count does not match reels";
		}
		
		for (let i = 0; i < targets.length; i++) {
			this.reelMappers[i].SetTarget(targets[i].position, force);
		}
    }

	// public GetSymbols(numSymbolsPerReel: number) {
	// 	let symbols: number[][] = [];
	// 	for (let i = 0; i < this.reelMappers.length; i++) {
	// 		symbols.push(this.reelMappers[i].GetSymbols(numSymbolsPerReel));
	// 	}

	// 	return symbols;
	// }

	public AddOverlay(overlay: S2_ReelSetMapperOverlay) {

		// Log.Debug(this.logGroup, "Adding overlay " + this.overlays.length + ": " + JSON.stringify(overlay));

		this.overlays.push(overlay);
		this.numReelsOverlayed = this.windowSymbolSize.Width;

		// add on flat overlay
		for (let ri = 0; ri < overlay.rect.width/* && ri + overlay.rect.x < this.windowSymbolSize.width*/; ri++) {

			// reel index
			let r = ri + overlay.rect.x;
			if (r >= 0 && r < this.windowSymbolSize.Width) {

				for (let si = 0; si < overlay.rect.height && si + overlay.rect.y < this.windowSymbolSize.Height; si++) {

					// invert symbol index, reel mapper maps symbol bottom to top, overlays want to map symbols top to bottom
					let s = this.windowSymbolSize.Height - si - overlay.rect.y -1;

					if (s >= 0 && s < this.windowSymbolSize.Height) {
						this.flatOverlay[r].symbols[s] = overlay.symbol;
					}
				}

				// set overlays to reels
				//this.reelMappers[r].SetOverlay(this.flatOverlay[r].symbols);
			}
		}

		// set overlays to reels
		for (let ri = 0; ri < this.flatOverlay.length; ri++) {
			this.reelMappers[ri].SetOverlay(this.flatOverlay[ri].symbols);
		}
	}

	public ClearOverlays() {

		// Log.Debug(this.logGroup, "Clearing overlays");

		// clear overlays
		this.overlays = [];

		// clear flat overlay
		for (let ri = 0; ri < this.flatOverlay.length; ri++) {

			for (let si = 0; si < this.flatOverlay[ri].symbols.length; si++) {
				this.flatOverlay[ri].symbols[si] = ReelMapper.NoOverlaySymbolIndex;
			}

			this.reelMappers[ri].ClearOverlay();
		}
	}

	public GetSymbols2(): ReelSymbolsToDisplay[][]
	{
		let symbols: ReelSymbolsToDisplay[][] = [];
		for (let i = 0; i < this.reelMappers.length; i++) {
			symbols.push(this.reelMappers[i].GetSymbols2());
		}

		return symbols;
	}
}
// }